import { TwilsockError } from "./twilsockerror";

class TransportUnavailableError extends TwilsockError {
  constructor(description: string) {
    super(description);
  }
}

export { TransportUnavailableError };
